import React from 'react';
interface SectionLabelProps {
  children: React.ReactNode;
  align?: 'left' | 'center';
}
export function SectionLabel({
  children,
  align = 'left'
}: SectionLabelProps) {
  return <p className={`flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.22em] text-terracotta ${align === 'center' ? 'justify-center' : ''}`} data-id="element-233" data-mp="2yf2rmpqux7qm">
      <span className="h-px w-8 bg-terracotta/40" aria-hidden="true" data-id="element-234" data-mp="33bjihrpfy07e" />
      {children}
    </p>;
}